import { render, staticRenderFns } from "./MensajeEnviado.vue?vue&type=template&id=d60297fe"
import script from "./MensajeEnviado.vue?vue&type=script&lang=js"
export * from "./MensajeEnviado.vue?vue&type=script&lang=js"
import style0 from "./MensajeEnviado.vue?vue&type=style&index=0&id=d60297fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports